import { render } from "./P065.vue?vue&type=template&id=36037638&scoped=true"
import script from "./P065.vue?vue&type=script&lang=js"
export * from "./P065.vue?vue&type=script&lang=js"

import "./P065.vue?vue&type=style&index=0&id=36037638&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36037638"]])

export default __exports__